import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { HTTP_VERBS, requestHttp } from "../../../../utils/HttpRequest";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

export const PropertyGrafBarChartAnio = (item) => {
  const [ precipitationanio, setPrecipitationanio ] = useState([]);
  //console.log({item: item})             

  //anio       
  useEffect(() => {
    const getData = async ()=>{
        try {                                                    
          item.anio ? getPrecipitationanio():console.log('');            
        } catch (error) {
            console.log(error)
        }             
    }    
    getData();         
        
  },[item.anio])
  //getPrecipitation
  const getPrecipitationanio = async ()=>{                
    try {                      
        const response = await requestHttp(
            {
                method: HTTP_VERBS.GET,
                endpoint: '/precipitations/anio',                         
                params: makePropertiesFiltersanio()                                     
            }
        );             
        const {data} = response;                
        setPrecipitationanio(data);    
        //console.log({dataAnio: data})  
            
    } catch (error) {
        if(error.response.status === 401){
          console.log('')
        }else{
            console.log(error)
        }
    }    
  }
  const makePropertiesFiltersanio = ()=>{
      const filters = {};                                           
          filters['anio'] = item.anio?item.anio:console.log('');               
      return filters;       
  }

  const generateChartData = () => {
    const uniqueFincas = [...new Set(precipitationanio.map((itemPrec) => itemPrec.Finca))];
    const uniqueYears = [...new Set(precipitationanio.map((itemPrec) => itemPrec.anio))];    
    //console.log({años: uniqueYears})
    //console.log({fincas: uniqueFincas})
    const datasets = uniqueYears.map((year) => {
      const dataForYear = uniqueFincas.map((finca) => {
        const matchingData = precipitationanio.find(
          (data) => data.Finca === finca && data.anio === year
        );
        return matchingData ? matchingData.totalLLuvia: 0;
      });

      return {
        label: `Año ${year}`,
        data: dataForYear,
        backgroundColor: `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.2)`,
        borderColor: ["#blue"],
        borderWidth: 1,
      };
    });

    return { labels: uniqueFincas, datasets };
  };
  
  const chartData = generateChartData();

  const options = {
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Precipitación (mm)',
        },
      },
    },
  };
  

  /*
  const data = {
    labels: sem,
    datasets:[{
       label: "mm", 
       data: precipitacion, 
       tension: 0.2,
       borderColor: "blue",
       borderWidth: 2,
       fill: true,
       backgroundColor: 'blue'       
    }],
  };

  const options = {
    maintainAspectRatio:false,
    responsive: true,

    plugins:{
      legend:{
        display: false,
        position: 'top',
      },
    },
  */
    /*scales:{
      y:{
        min: 0,
      },
    },

    plugins:{
      legend:{
        display: true,
        position: 'top',
      },
    },
    tooltip:{
      intersect: false,
      mode: 'index',
      callbacks:{
        label: function (context){
          const label = context.dataset.label || '';
          const value = context.formattedValue;
          return `${label}: ${value} mm`
        },
      },
    },  */
  
  //<Bar data={chartData} options={options} />
  return (
    <div>
     <h2>Gráfico de Precipitación de Fincas Ultimos 3 Años</h2>
     <Bar data={chartData} options={options} />
    </div>
  )
}


